import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01de38ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filter-parameter-types__name" }

import { computed, onMounted, PropType, ref, watch } from "vue";
import { OptionItemModel } from "../../../models";
import { RectangleStackIcon } from "tir-style-system/icons/outline";

/**Параметры */

export default /*#__PURE__*/_defineComponent({
  __name: 'FilterTypeParameter',
  props: {
  /**Данные опции фильтра */
  item: {
    type: Object as PropType<OptionItemModel>,
    required: true,
  },
},
  setup(__props) {

const props = __props;



/**Ссылка на дом элемента фильтра */
const $itemFilter = ref<InstanceType<typeof HTMLElement>>();

/**После рендера компонента */
onMounted(() => {
  props.item.Width = $itemFilter.value?.offsetWidth;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "$itemFilter",
    ref: $itemFilter,
    class: "filter-parameter-types__item"
  }, [
    _createVNode(_unref(RectangleStackIcon), { class: "filter-parameter-types__icon" }),
    _createElementVNode("div", _hoisted_1, _toDisplayString(__props.item.Name), 1)
  ], 512))
}
}

})